import * as api from "../api/index.js";
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action types
export const START_LOADING_DISCOUNT_CODES = 'START_LOADING_DISCOUNT_CODES';
export const END_LOADING_DISCOUNT_CODES = 'END_LOADING_DISCOUNT_CODES';
export const FETCH_DISCOUNT_CODES = 'FETCH_DISCOUNT_CODES';
export const CREATE_DISCOUNT_CODE = 'CREATE_DISCOUNT_CODE';
export const UPDATE_DISCOUNT_CODE = 'UPDATE_DISCOUNT_CODE';
export const DELETE_DISCOUNT_CODE = 'DELETE_DISCOUNT_CODE';
export const VALIDATE_DISCOUNT_CODE = 'VALIDATE_DISCOUNT_CODE';
export const APPLY_DISCOUNT_CODE = 'APPLY_DISCOUNT_CODE';
export const FETCH_DISCOUNT_CODE_STATS = 'FETCH_DISCOUNT_CODE_STATS';
export const DISCOUNT_CODE_ERROR = 'DISCOUNT_CODE_ERROR';

// Action creators
export const fetchDiscountCodes = (filters = {}, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING_DISCOUNT_CODES });
    const { data } = await api.fetchAllDiscountCodes(filters);
    dispatch({ type: FETCH_DISCOUNT_CODES, payload: data });
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
  } catch (error) {
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
    const errorMessage = error?.response?.data?.message || "Error fetching discount codes.";
    dispatch({ type: DISCOUNT_CODE_ERROR, payload: errorMessage });
    if (openSnackbar) {
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
  }
};

export const createDiscountCode = (codeData, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING_DISCOUNT_CODES });
    const { data } = await api.createDiscountCode(codeData);
    dispatch({ type: CREATE_DISCOUNT_CODE, payload: data });
    if (openSnackbar) {
      openSnackbar("Discount code created successfully.", SNACKBAR_DURATION_MS, getSnackbarColor("Discount code created successfully."));
    }
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
    return data;
  } catch (error) {
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
    const errorMessage = error?.response?.data?.message || "Error creating discount code.";
    dispatch({ type: DISCOUNT_CODE_ERROR, payload: errorMessage });
    if (openSnackbar) {
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
    throw error;
  }
};

export const updateDiscountCode = (id, codeData, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING_DISCOUNT_CODES });
    const { data } = await api.updateDiscountCode(id, codeData);
    dispatch({ type: UPDATE_DISCOUNT_CODE, payload: data });
    if (openSnackbar) {
      openSnackbar("Discount code updated successfully.", SNACKBAR_DURATION_MS, getSnackbarColor("Discount code updated successfully."));
    }
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
    return data;
  } catch (error) {
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
    const errorMessage = error?.response?.data?.message || "Error updating discount code.";
    dispatch({ type: DISCOUNT_CODE_ERROR, payload: errorMessage });
    if (openSnackbar) {
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
    throw error;
  }
};

export const deleteDiscountCode = (id, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING_DISCOUNT_CODES });
    await api.deleteDiscountCode(id);
    dispatch({ type: DELETE_DISCOUNT_CODE, payload: id });
    if (openSnackbar) {
      openSnackbar("Discount code deleted successfully.", SNACKBAR_DURATION_MS, getSnackbarColor("Discount code deleted successfully."));
    }
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
  } catch (error) {
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
    const errorMessage = error?.response?.data?.message || "Error deleting discount code.";
    dispatch({ type: DISCOUNT_CODE_ERROR, payload: errorMessage });
    if (openSnackbar) {
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
  }
};

export const validateDiscountCode = (codeData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.validateDiscountCode(codeData);
    dispatch({ type: VALIDATE_DISCOUNT_CODE, payload: data });
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || "Error validating discount code.";
    dispatch({ type: DISCOUNT_CODE_ERROR, payload: errorMessage });
    if (openSnackbar) {
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
    return { success: false, valid: false, message: errorMessage };
  }
};

export const applyDiscountCode = (codeData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.applyDiscountCodeUsage(codeData);
    dispatch({ type: APPLY_DISCOUNT_CODE, payload: data });
    if (openSnackbar) {
      openSnackbar("Discount code applied successfully.", SNACKBAR_DURATION_MS, getSnackbarColor("Discount code applied successfully."));
    }
    return data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || "Error applying discount code.";
    dispatch({ type: DISCOUNT_CODE_ERROR, payload: errorMessage });
    if (openSnackbar) {
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
    throw error;
  }
};

export const fetchDiscountCodeStats = (filters = {}, openSnackbar) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING_DISCOUNT_CODES });
    const { data } = await api.getDiscountCodeStats(filters);
    dispatch({ type: FETCH_DISCOUNT_CODE_STATS, payload: data });
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
  } catch (error) {
    dispatch({ type: END_LOADING_DISCOUNT_CODES });
    const errorMessage = error?.response?.data?.message || "Error fetching discount code statistics.";
    dispatch({ type: DISCOUNT_CODE_ERROR, payload: errorMessage });
    if (openSnackbar) {
      openSnackbar(errorMessage, SNACKBAR_DURATION_MS, getSnackbarColor("errorMessage"));
    }
  }
};